export type Color = `#${string}`

const darkred: Color = '#8b0000'

const dimgray: Color = '#686a66'
const lightseagreen: Color = '#00a4a8'
const goldenrod: Color = '#c8a800'
const tomato: Color = '#f54234'

export const Color = { darkred, dimgray, lightseagreen, goldenrod, tomato }
